/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-unused-vars */

import React, { useState, useEffect } from 'react';

import { MDBInput } from 'mdb-react-ui-kit';

import "../style/css/inputfield.css"

interface Label {
  title: string;
}

interface Props {
  labels: Label[];
  initialValue: string[];
  onChange: (newValues: string[]) => void;
  readOnly?: boolean; // Ajout de la prop readOnly
}

const InputField: React.FC<Props> = ({ labels, initialValue, onChange, readOnly = false }) => {

  const [values, setValues] = useState<string[]>(initialValue);

  useEffect(() => {
    setValues(initialValue);
  }, [initialValue]);

  const handleChange = (index: number, newValue: string) => {
    const newValues = [...values];
    newValues[index] = newValue;
    setValues(newValues);
    onChange(newValues);
  };

  return (

    <div className='inputfields'>

      {labels.map((label, index) => (

        <MDBInput
          key={index}
          value={values[index] || ' '} // Si la valeur est vide, afficher un espace
          onChange={(e) => handleChange(index, e.target.value)}
          label={label.title}
          labelStyle={{ color: '#5C81B1' }}
          className='controlledValue'
          id={`controlledValue-${index}`}
          type='text'
          readOnly={readOnly} // Ajout de l'attribut readOnly
        />
      ))}

    </div>
    
  );
};

export default InputField;
